<div *ngIf="(dataFilterConfig?.filterLimit && filtersList.length > dataFilterConfig?.filterLimit) || enableFiltering" class="search-section-wrapper">
    <div class="search-section">
        <input type="text"
               [(ngModel)]="filterQuery"
               (ngModelChange)="setFilterQuery($event)"
               placeholder="Search"
               maxlength="250"
               (focus)="$event.stopPropagation()"
               (click)="$event.stopPropagation()">
        <i class="icon-search"></i>
        <button id="clear-filter-search"
                appTrackClickButton
                type="button"
                class="icon-cross_16px clear-control"
                [hidden]="!filterQuery.length"
                (click)="$event.stopPropagation(); setFilterQuery('')"></button>
    </div>
</div>
<ng-container *ngIf="hasFilteredResults && innerOptionsList.length; else noData">
    <div class="options-wrapper">
        <label *ngIf="!filterQuery.length && innerOptionsList.length" class="option" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <input type="checkbox"
                   (click)="toggleAllChecked(); check()"
                   (keydown.enter)="toggleAllChecked(); check()"
                   [checked]="isAllChecked"
                   [indeterminate]="isSomeChecked">
            <span>{{ multiValuePrefix || defaultLabel }}</span>
        </label>
        <ul *ngIf="innerOptionsList.length" class="options-list">
            <li *ngFor="let option of innerOptionsList | listFilter: { value: pipeFilterQuery } : false"
                [class.separator]="option.hasSeparator">
                <label class="option home-item" [class.home-item]="+option['key'] === homeSiteId" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    <input type="checkbox" [(ngModel)]="option.checked" (change)="check()">
                    <span appEllipsisTooltip class="ellipsis" [innerHTML]="option['value'] | htmltransfrom | highlight: pipeFilterQuery"></span>
                    <i *ngIf="+option['key'] === homeSiteId" class="icon-home"
                       [containerClass]="'white-tooltip'"
                       [tooltip]="homeText"
                       container="body"
                       [adaptivePosition]="false"
                    ></i>
                    <ng-template #homeText>
                        <div>
                            <span class="white-tooltip__label">Home site</span>
                            <span class="white-tooltip__content">You can change your home site by clicking DGuest on the dark header.</span>
                        </div>
                    </ng-template>
                </label>
            </li>
        </ul>
    </div>

    <div *ngIf="enableActions" class="footer">
        <button id="cancel-filter"
                appTrackClickButton
                (click)="dismiss()"
                type="button"
                class="button secondary small">Cancel</button>
        <button id="apply-grid-filter"
                appTrackClickButton
                (click)="apply()"
                [disabled]="!isSomeChecked && !isAllChecked"
                type="button"
                class="button primary small">Apply</button>
    </div>
</ng-container>

<ng-template #noData>
    <div class="no-results">
        <div class="no-results__text">No records found</div>
    </div>
</ng-template>
